.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  max-width: 720px;
  margin: 0 auto;
  padding: var(--tuna-spacing-4);
}
